import { render, staticRenderFns } from "./jqs_chengji.vue?vue&type=template&id=55087a04&scoped=true"
import script from "./jqs_chengji.vue?vue&type=script&lang=js"
export * from "./jqs_chengji.vue?vue&type=script&lang=js"
import style0 from "./jqs_chengji.vue?vue&type=style&index=0&id=55087a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55087a04",
  null
  
)

export default component.exports